import { render, staticRenderFns } from "./prefooter.vue?vue&type=template&id=b15708d4"
import script from "./prefooter.vue?vue&type=script&lang=js"
export * from "./prefooter.vue?vue&type=script&lang=js"
import style0 from "./prefooter.vue?vue&type=style&index=0&id=b15708d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports